import React from 'react';

type KPIStatus = 'ok' | 'warning' | 'critical' | 'default';

const statusColors: Record<KPIStatus, string> = {
  ok:       'border-emerald-400/50 bg-emerald-50',
  warning:  'border-amber-400/50 bg-amber-50',
  critical: 'border-red-400/50 bg-red-50',
  default:  'border-hydro-border',
};

interface KPICardProps {
  label:     string;
  value:     string | number | null | undefined;
  unit?:     string;
  icon?:     string;
  trend?:    number;
  status?:   KPIStatus;
  subtitle?: string;
}

export default function KPICard({ label, value, unit, icon, trend, status = 'default', subtitle }: KPICardProps) {
  const borderClass = statusColors[status] ?? statusColors.default;

  return (
    <div className={`card border ${borderClass} flex flex-col gap-1`}>
      <div className="flex items-start justify-between">
        <p className="kpi-label">{label}</p>
        {icon && <span className="text-lg">{icon}</span>}
      </div>
      <div className="flex items-end gap-2 mt-1">
        <span className={`kpi-value ${
          status === 'critical' ? 'text-red-600' :
          status === 'warning'  ? 'text-amber-600' :
          status === 'ok'       ? 'text-emerald-700' : 'text-slate-900'
        }`}>
          {value ?? '—'}
        </span>
        {unit && <span className="text-sm text-slate-500 mb-1">{unit}</span>}
      </div>
      {(subtitle !== undefined || trend !== undefined) && (
        <div className="flex items-center gap-2 mt-1">
          {subtitle && <span className="text-xs text-slate-500">{subtitle}</span>}
          {trend !== undefined && (
            <span className={`text-xs font-medium ${trend >= 0 ? 'text-emerald-600' : 'text-red-600'}`}>
              {trend >= 0 ? '↑' : '↓'} {Math.abs(trend).toFixed(1)}%
            </span>
          )}
        </div>
      )}
    </div>
  );
}
